import { MILLISECONDS } from '@chiroup/core/constants/time';
import { Condition } from '@chiroup/core/types/Condition.type';
import { use } from 'react';
import { useQuery } from 'react-query';
import { MeContext } from '../contexts/me.context';
import { useSandboxClinicalData } from '../contexts/sandboxClinicalData.context';
import reportService from '../services/report.service';

type Props = {
  refetchOnMount?: boolean;
  ids: number[];
};

const useConditionDetails = ({ ids, refetchOnMount = true }: Props) => {
  const sandbox = useSandboxClinicalData();
  const meContext = use(MeContext);
  const { data, isFetching } = useQuery<{
    data: Partial<Condition>[];
  }>(
    ['conditionDetails', ids],
    () =>
      sandbox
        ? { data: sandbox.conditions.filter(condition => ids.includes(condition.ID)) }
        : reportService.getConditionDetails(
            meContext?.me.selectedClinic?.ID || -1,
            meContext?.me.ID,
            ids,
            true
          ),
    {
      refetchOnWindowFocus: false,
      refetchOnMount,
      staleTime: MILLISECONDS.inMinutes(5),
    }
  );

  return { data, isFetching };
};

export default useConditionDetails;
